(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    /* ES Hybrid-Akzente (19.10.2026): Kasten <es-hybrid-box> unter dem Warenkorb-Knopf.
   Den Kauf schickt assets/product-form.js (#esHybridPayload -> esBuild), damit Fehleranzeige,
   Warenkorb-Drawer, Zähler und Events genau wie beim normalen Kauf laufen.
   Ohne Häkchen liefert esBuild null -> normaler Kauf unverändert. */
(() => {
  if (!window.customElements || customElements.get('es-hybrid-box')) return;
  const QUICK = '#quick-add-modal-content, .quick-add-modal__content, .quick-add-modal';
  const CODE = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';

  class EsHybridBox extends HTMLElement {
    connectedCallback() {
      if (this.closest(QUICK)) return;
      if (!this._esReady) {
        this._toggle = this.querySelector('[data-es-hy-toggle]');
        this._foils = this.querySelector('[data-es-hy-foils]');
        this._img = this.querySelector('[data-es-hy-img]');
        this._cap = this.querySelector('[data-es-hy-cap]');
        this._warn = this.querySelector('[data-es-hy-warn]');
        this._radios = Array.from(this.querySelectorAll('input[data-es-hy-foil]'));
        if (!this._toggle || !this._foils || this._radios.length === 0) return;
        this._esReady = true;
        this._inCart = this.dataset.inCart === '1';
        const group = 'es-hy-' + Math.random().toString(36).slice(2, 10);
        this._radios.forEach((radio) => {
          radio.name = group;
          radio.addEventListener('change', () => this._sync());
        });
        this._toggle.addEventListener('change', () => this._sync());
      }
      if (this._abort) this._abort.abort();
      this._abort = new AbortController();
      const signal = this._abort.signal;
      /* featured-product-Vorlagen (VX2): variant-picker.js morpht den ganzen Bereich und entfernt dabei
         data-es-hybrid-on am Block. variant:update kommt erst nach dem Morph -> Zustand neu setzen. */
      document.addEventListener('variant:update', () => {
        if (!this.hidden) this._sync();
      }, { signal });
      /* Warenkorb geändert: prüfen, ob dieser Skin schon ohne Hybrid-Akzente drinliegt (Hinweis im Kasten). */
      document.addEventListener('cart:update', (event) => this._onCart(event), { signal });
      customElements.whenDefined('product-form-component').then(() => this._reveal());
    }

    disconnectedCallback() {
      if (this._abort) this._abort.abort();
      this._abort = null;
    }

    /* Nur sichtbar, wenn product-form.js den Hybrid-Versand kann und das Formular passt. */
    _reveal() {
      const ProductForm = customElements.get('product-form-component');
      const form = this._form();
      if (!ProductForm || ProductForm.esHybridApi !== 1 || !form) return;
      if (form.querySelector('input[type="file"]')) return;
      for (const input of document.querySelectorAll('input[type="file"][form]')) {
        if (input.getAttribute('form') === form.getAttribute('id')) return;
      }
      this.hidden = false;
      this._sync();
    }

    _block() {
      const extras = this.closest('.es-buy-extras');
      const block = extras ? extras.previousElementSibling : null;
      return block && block.classList.contains('buy-buttons-block') ? block : null;
    }

    _form() {
      const block = this._block();
      const form = block ? block.querySelector('form[data-type="add-to-cart-form"]') : null;
      /* getAttribute: form.id liefert wegen <input name="id"> das Eingabefeld, nicht die Formular-ID. */
      return form && form.getAttribute('id') === this.dataset.formId ? form : null;
    }

    _picked() {
      return this._radios.find((radio) => radio.checked) || null;
    }

    _sync() {
      const on = this._toggle.checked;
      if (on && !this._picked()) this._radios[0].checked = true;
      const pick = on ? this._picked() : null;
      const foilImg = pick && pick.dataset.img ? pick.dataset.img : '';
      this._foils.hidden = !on;
      this.classList.toggle('es-hy--on', !!pick);
      if (this._img) {
        const src = foilImg || this.dataset.exSrc || '';
        if (src && this._img.getAttribute('src') !== src) this._img.setAttribute('src', src);
        this._img.alt = foilImg ? pick.dataset.label || '' : this.dataset.exAlt || '';
      }
      if (this._cap) {
        this._cap.textContent = foilImg ? (this.dataset.tFoil || '') + ': ' + (pick.dataset.label || '') : this.dataset.exCap || '';
      }
      if (this._warn) this._warn.hidden = !(on && this._inCart);
      const block = this._block();
      if (block) block.toggleAttribute('data-es-hybrid-on', !!pick && !this.hidden);
    }

    _onCart(event) {
      const cart = event && event.detail ? event.detail.resource : null;
      if (cart && Array.isArray(cart.items)) {
        this._setInCart(cart.items);
        return;
      }
      if (this.hidden) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((response) => response.json())
        .then((data) => {
          if (data && Array.isArray(data.items)) this._setInCart(data.items);
        })
        .catch(() => {});
    }

    /* true, wenn eine Position dieses Produkts OHNE Hybrid-Paar (_es_pair) im Warenkorb liegt. */
    _setInCart(items) {
      const productId = String(this.dataset.productId || '');
      this._inCart = items.some(
        (item) => item && String(item.product_id) === productId && !(item.properties && item.properties._es_pair)
      );
      if (this._esReady) this._sync();
    }

    /* Für product-form.js: true, wenn beim Kauf Hybrid-Akzente mitgehen. */
    esActive() {
      return this._esReady === true && !this.hidden && this._toggle.checked && !!this._picked();
    }

    /* Für product-form.js: items[] für cart/add.js (Skin zuerst, dann Hybrid) oder null.
       formData = FormData des Produktformulars zum Kaufzeitpunkt (aktuelle Variante, Properties). */
    esBuild(formData, quantity) {
      if (!this.esActive()) return null;
      const pick = this._picked();
      const hybridId = Number(pick.value);
      const skinId = Number(formData.get('id'));
      if (!hybridId || !skinId) return null;
      const qty = Math.max(1, Math.floor(Number(quantity) || 1));
      const d = this.dataset;
      const keyRef = d.kRef || 'Hybrid-Kennung';
      const keyFor = d.kFor || 'Für Skin';
      const ref = this._ref();
      const skinProps = {};
      for (const [key, value] of formData.entries()) {
        const match = /^properties\[(.+)\]$/.exec(key);
        if (match && typeof value === 'string' && value !== '') skinProps[match[1]] = value;
      }
      /* Am Skin nur die Kennung (kein Folienname): gilt nicht als Auftrag, falls die Hybrid-Zeile im Warenkorb entfernt wird. */
      skinProps[keyRef] = ref;
      skinProps._es_pair = ref;
      const variantTitle = this._variantTitle(skinId);
      const hybridProps = {};
      hybridProps[keyFor] = (d.productTitle || '') + (variantTitle ? ' – ' + variantTitle : '');
      hybridProps[keyRef] = ref;
      hybridProps._es_pair = ref;
      hybridProps._es_skin_variant = String(skinId);
      const skin = { id: skinId, quantity: qty, properties: skinProps };
      const sellingPlan = formData.get('selling_plan');
      if (sellingPlan) skin.selling_plan = Number(sellingPlan);
      const hybrid = { id: hybridId, quantity: qty, parent_id: skinId, properties: hybridProps };
      return { ref: ref, itemCount: qty * 2, items: [skin, hybrid] };
    }

    _variantTitle(id) {
      if (!this._titles) {
        this._titles = new Map();
        try {
          const ids = (this.dataset.variantIds || '').split(',');
          const titles = JSON.parse(this.dataset.variantTitles || '[]');
          ids.forEach((value, index) => {
            if (value && typeof titles[index] === 'string') this._titles.set(value.trim(), titles[index]);
          });
        } catch (error) {
          this._titles = new Map();
        }
      }
      const title = this._titles.get(String(id)) || '';
      return title === 'Default Title' ? '' : title;
    }

    _ref() {
      const bytes = new Uint8Array(6);
      if (window.crypto && window.crypto.getRandomValues) {
        window.crypto.getRandomValues(bytes);
      } else {
        for (let i = 0; i < bytes.length; i += 1) bytes[i] = Math.floor(Math.random() * 256);
      }
      let out = 'HY-';
      for (let i = 0; i < bytes.length; i += 1) out += CODE[bytes[i] % CODE.length];
      return out;
    }
  }

  customElements.define('es-hybrid-box', EsHybridBox);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["es-felgen-xsell"] && !Shopify.designMode) return;
  try {
    /* ES Komplett-Look (30.10.2026): <es-look-box> vor den Kaufknöpfen. Die Felgen gehen über assets/product-form.js
   (#esLookItems -> esItems) im selben cart/add.js mit, damit Drawer, Zähler und Fehleranzeige wie beim normalen
   Kauf laufen. Ohne Häkchen liefert esItems [] -> normaler Kauf unverändert. */
(() => {
  if (!window.customElements || customElements.get('es-look-box')) return;
  const QUICK = '#quick-add-modal-content, .quick-add-modal__content, .quick-add-modal';

  class EsLookBox extends HTMLElement {
    connectedCallback() {
      if (this.closest(QUICK)) return;
      if (!this._esReady) {
        this._rim = this.querySelector('[data-es-look-rim]');
        this._rimRow = this._rim ? this._rim.closest('.es-look__row') : null;
        this._deck = this.querySelector('[data-es-look-deck]');
        this._deckRow = this.querySelector('[data-es-look-deck-row]');
        this._note = this.querySelector('[data-es-look-note]');
        if (!this._rim) return;
        this._esReady = true;
        this._rim.addEventListener('change', () => this._sync());
        if (this._deck) this._deck.addEventListener('change', () => this._pickDeck(this._deck.checked));
      }
      if (this._abort) this._abort.abort();
      this._abort = new AbortController();
      document.addEventListener('variant:update', () => this._syncDeck(), { signal: this._abort.signal });
      customElements.whenDefined('product-form-component').then(() => this._reveal());
      this._resolve();
    }

    disconnectedCallback() {
      if (this._abort) this._abort.abort();
      this._abort = null;
    }

    _form() {
      const form = document.getElementById(this.dataset.formId || '');
      return form instanceof HTMLFormElement ? form : null;
    }

    /* Nur sichtbar, wenn product-form.js Zusatz-Artikel mitschicken kann und das Formular passt. */
    _reveal() {
      const ProductForm = customElements.get('product-form-component');
      if (!ProductForm || ProductForm.esLookApi !== 1 || !this._form()) return;
      this.hidden = false;
      this._syncDeck();
      this._sync();
    }

    /* Felgen-Variante (Modell + Design) holen: templates/product.es-vid.liquid gibt
       „ES-VID:<Varianten-ID>:<gewählte Optionswert-IDs>:<kaufbar>“ aus. Nur wenn die gewählten Werte genau den
       angefragten entsprechen (sonst wäre es die erste Variante, also falsches Modell/Design), wird das Häkchen frei. */
    _resolve() {
      if (this._vid || this._loading || !this.dataset.src) return;
      this._loading = true;
      const asked = (new URL(this.dataset.src, location.origin).searchParams.get('option_values') || '')
        .split(',')
        .filter(Boolean)
        .sort()
        .join(',');
      fetch(this.dataset.src)
        .then((response) => (response.ok ? response.text() : ''))
        .then((text) => {
          const match = /ES-VID:(\d+):([\d,]*):(true|false)/.exec(text || '');
          const got = match ? match[2].split(',').filter(Boolean).sort().join(',') : '';
          if (match && match[3] === 'true' && asked !== '' && got === asked) {
            this._vid = Number(match[1]);
            this._rim.disabled = false;
          } else if (this._rimRow) {
            this._rimRow.hidden = true;
          }
        })
        .catch(() => {
          if (this._rimRow) this._rimRow.hidden = true;
        })
        .finally(() => {
          this._loading = false;
          this._sync();
        });
    }

    _sync() {
      const on = this.esActive();
      if (this._note) this._note.hidden = !on;
      const form = this._form();
      const block = form ? form.closest('.buy-buttons-block') : null;
      if (block) block.toggleAttribute('data-es-look-on', on);
      const rows = Array.from(this.querySelectorAll('.es-look__row'));
      if (!this.hidden && rows.length > 0 && rows.every((row) => row.hidden)) this.hidden = true;
    }

    /* Trittbrett-Häkchen = Optionswert „Mit Trittbrett“ / „Ohne Trittbrett“ in der Variantenauswahl. */
    _deckInputs() {
      const scope = this._form()?.closest('.shopify-section') || document;
      /** @param {string | undefined} id */
      const find = (id) => (id ? scope.querySelector(`variant-picker input[data-option-value-id="${id}"]`) : null);
      return { on: find(this.dataset.tbOn), off: find(this.dataset.tbOff) };
    }

    _syncDeck() {
      if (!this._deck || !this._deckRow) return;
      const { on, off } = this._deckInputs();
      if (!on || !off) {
        this._deckRow.hidden = true;
      } else {
        this._deckRow.hidden = false;
        this._deck.checked = on.checked;
      }
      this._sync();
    }

    _pickDeck(want) {
      const { on, off } = this._deckInputs();
      const target = want ? on : off;
      if (target && !target.checked) target.click();
    }

    /* Für product-form.js: true, wenn beim Kauf die Felgenaufkleber mitgehen. */
    esActive() {
      return this._esReady === true && !this.hidden && !this._rim.disabled && this._rim.checked && !!this._vid;
    }

    /* Für product-form.js: Zusatz-Artikel für cart/add.js (gleiche Menge wie der Skin) oder []. */
    esItems(formData, quantity) {
      if (!this.esActive()) return [];
      const qty = Math.max(1, Math.floor(Number(quantity) || 1));
      const properties = {};
      properties[this.dataset.kFor || 'Passend zu'] = this.dataset.productTitle || '';
      return [{ id: this._vid, quantity: qty, properties: properties }];
    }
  }

  customElements.define('es-look-box', EsLookBox);
})();
  } catch(e) { console.error(e); }
})();

})();
